import { render, staticRenderFns } from "./pg-merchant-view.vue?vue&type=template&id=698383c7&"
import script from "./pg-merchant-view.vue?vue&type=script&lang=js&"
export * from "./pg-merchant-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports